import mutations from './mutations'

const namespaced = true

const state = {
  active: true
}

export default {
  namespaced,
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/sidebar/index.js